<template lang="pug">
  div(name="chart")
    .col-12
      .chart-container(v-bind:id="containerID")
</template>
<script>
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
// import am4themesspiritedaway from '@amcharts/amcharts4/themes/spiritedaway'
import am4themesanimated from '@amcharts/amcharts4/themes/animated'

// am4core.useTheme(am4themesspiritedaway)
am4core.useTheme(am4themesanimated)

export default {
  props: {
    chartdata: Array,
    graphType: {
      type: String,
      default: 'XYChartBars'
    }
    // graphType: ['XYChartBars', 'XYChartLines', 'PieChart']

  },
  data () {
    return {
      name: 'chart',
      chart: {},
      containerID: this.getChartId()
    }
  },
  computed: {
    cd: function () {
      return this.chartdata
    }
  },
  mounted () {
    // this.containerID = this.getChartId()
    if (this.graphType === 'XYChartBars') {
      this.chart = am4core.create(this.containerID, am4charts.XYChart)
      this.chart.hiddenState.properties.opacity = 0 // this creates initial fade-in

      this.chart.data = this.cd

      var categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis())
      categoryAxis.renderer.grid.template.location = 0
      categoryAxis.dataFields.category = 'label'
      if (this.cd.length > 10) {
        categoryAxis.renderer.labels.template.disabled = true
      }

      var valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis())
      valueAxis.min = 0
      // valueAxis.max = 24000
      valueAxis.title.text = 'Звонки'
      valueAxis.strictMinMax = true
      valueAxis.renderer.minGridDistance = 30
      // axis break
      // var axisBreak = valueAxis.axisBreaks.create()
      // axisBreak.startValue = 600
      // axisBreak.endValue = 1000
      // axisBreak.breakSize = 0.005

      // make break expand on hover
      // var hoverState = axisBreak.states.create('hover')
      // hoverState.properties.breakSize = 1
      // hoverState.properties.opacity = 0.1
      // hoverState.transitionDuration = 1500

      // axisBreak.defaultState.transitionDuration = 1000

      var series = this.chart.series.push(new am4charts.ColumnSeries())
      series.dataFields.categoryX = 'label'
      series.dataFields.valueY = 'count'
      series.columns.template.tooltipText = '{categoryX}\n{valueY}'
      series.columns.template.tooltipY = 0
      series.columns.template.strokeOpacity = 0

      // as by default columns of the same series are of the same color, we add adapter which takes colors from chart.colors color set
      series.columns.template.adapter.add('fill', (fill, target) => {
        return this.chart.colors.getIndex(target.dataItem.index)
      })
      // series.columns.template.column.cornerRadiusTopLeft = 5
      // series.columns.template.column.cornerRadiusTopRight = 5
      series.heatRules.push({
        'target': series.columns.template,
        'property': 'fill',
        // 'min': am4core.color('#b2d8d8'),
        // 'max': am4core.color('#004c4c'),
        'dataField': 'valueY'
      })
      //
      // var heatLegend = this.chart.createChild(am4charts.HeatLegend)
      // heatLegend.width = am4core.percent(100)
      // heatLegend.minColor = am4core.color('#51BACB')
      // heatLegend.maxColor = am4core.color('#003A4B')
      // heatLegend.minValue = 0
      // heatLegend.maxValue = 400
    } else if (this.graphType === 'PieChart') {
      this.chart = am4core.create(this.containerID, am4charts.PieChart)
      this.chart.hiddenState.properties.opacity = 0 // this creates initial fade-in
      // Add data
      this.chart.data = this.cd

      // Add and configure Series
      var pieSeries = this.chart.series.push(new am4charts.PieSeries())
      pieSeries.dataFields.value = 'count'
      pieSeries.dataFields.category = 'label'
      pieSeries.slices.template.stroke = am4core.color('#fff')
      pieSeries.slices.template.strokeWidth = 2
      pieSeries.slices.template.strokeOpacity = 1
      // Disable ticks and labels
      pieSeries.labels.template.disabled = true
      pieSeries.ticks.template.disabled = true
      // Add a legend
      this.chart.legend = new am4charts.Legend()

      // Let's cut a hole in our Pie chart the size of 40% the radius
      // this.chart.innerRadius = am4core.percent(30)

      // This creates initial animation
      pieSeries.hiddenState.properties.opacity = 1
      pieSeries.hiddenState.properties.endAngle = -90
      pieSeries.hiddenState.properties.startAngle = -90
    } else if (this.graphType === 'XYChartLines') {
      this.chart = am4core.create(this.containerID, am4charts.XYChart)
      this.chart.hiddenState.properties.opacity = 0 // this creates initial fade-in
      // Add data
      this.chart.data = this.cd
      var linecategoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis())
      linecategoryAxis.renderer.grid.template.location = 0
      linecategoryAxis.dataFields.category = 'label'
      // eslint-disable-next-line
      var linevalueAxis = this.chart.yAxes.push(new am4charts.ValueAxis())
      linevalueAxis.title.text = 'Секунды'

      // Create series
      var lineseries = this.chart.series.push(new am4charts.LineSeries())
      lineseries.dataFields.valueY = 'avg'
      lineseries.dataFields.categoryX = 'label'
      lineseries.strokeWidth = 3
      lineseries.tooltipText = '{avg}'
      lineseries.tooltip.pointerOrientation = 'vertical'
      var lineseriesMin = this.chart.series.push(new am4charts.LineSeries())
      lineseriesMin.dataFields.valueY = 'min'
      lineseriesMin.dataFields.categoryX = 'label'
      lineseriesMin.stroke = am4core.color('#ea1616')
      lineseriesMin.tooltipText = '{min}'
      lineseriesMin.tooltip.pointerOrientation = 'vertical'
      lineseriesMin.strokeDasharray = '3,4'
      var lineseriesMax = this.chart.series.push(new am4charts.LineSeries())
      lineseriesMax.dataFields.valueY = 'max'
      lineseriesMax.dataFields.categoryX = 'label'
      lineseriesMax.stroke = am4core.color('#0fb20a')
      lineseriesMax.tooltipText = '{max}'
      lineseriesMax.tooltip.pointerOrientation = 'vertical'
      lineseriesMax.strokeDasharray = '3,4'

      this.chart.cursor = new am4charts.XYCursor()
      this.chart.cursor.snapToSeries = series
      this.chart.cursor.xAxis = linecategoryAxis

      // chart.scrollbarY = new am4core.Scrollbar();
      // this.chart.scrollbarX = new am4core.Scrollbar()

      // // Create axes
      // var dateAxis = this.chart.xAxes.push(new am4charts.DateAxis())
      // dateAxis.renderer.minGridDistance = 50
      // // eslint-disable-next-line
      // var linevalueAxis = this.chart.yAxes.push(new am4charts.ValueAxis())
      //
      // // Create series
      // var lineseries = this.chart.series.push(new am4charts.LineSeries())
      // lineseries.dataFields.valueY = 'count_avg'
      // lineseries.dataFields.dateX = 'label'
      // lineseries.strokeWidth = 2
      // lineseries.minBulletDistance = 10
      // // lineseries.tooltipText = '[bold]{date.formatDate()}:[/] {value1}\n[bold]{previousDate.formatDate()}:[/] {value2}'
      // lineseries.tooltip.pointerOrientation = 'vertical'
      //
      // // Create series
      // // var lineseriesmin = this.chart.series.push(new am4charts.LineSeries())
      // // lineseriesmin.dataFields.valueY = 'count_min'
      // // lineseriesmin.dataFields.dateX = 'label'
      // // lineseriesmin.strokeWidth = 2
      // // lineseriesmin.strokeDasharray = '3,4'
      // // lineseriesmin.stroke = lineseries.stroke
      // // Create series
      // // var lineseriesmax = this.chart.series.push(new am4charts.LineSeries())
      // // lineseriesmax.dataFields.valueY = 'count_max'
      // // lineseriesmax.dataFields.dateX = 'label'
      // // lineseriesmax.strokeWidth = 2
      // // lineseriesmax.strokeDasharray = '3,4'
      // // lineseriesmax.stroke = lineseries.stroke
      //
      // // Add cursor
      // this.chart.cursor = new am4charts.XYCursor()
      // this.chart.cursor.xAxis = dateAxis
    }
  },
  methods: {
    getChartId () {
      var chartId = Math.random() * 1000
      return 'chartContainer' + Math.round(chartId)
    }
  },
  beforeDestroy () {
    if (this.chart) {
      this.chart.dispose()
    }
  }
}
</script>

<style scoped>
  body {
    height:97vh;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  }
  .chart-container {
    width: 100%;
    height: 500px;
  }
</style>



// WEBPACK FOOTER //
// src/components/chart.vue